import { Redirect, Route, Switch } from 'react-router';
import React from 'react';
import { useHistory } from 'react-router-dom';
import Tabs from '../../components/Tabs';
import { ALL_EXCLUDED_AO3, AO3Endpoints, CONTACTED_AO3, MUTED_AUTHORS_AO3, PODIUM_TITLES_AO3,
  POPULAR_AO3, Routes, SENT_TO_CRM_AO3, TAB_NAME, WATCHLIST_AO3 } from '../../core/constants';
import { AllExcluded, Contacted, MutedAuthors,
  PodiumTitles, Popular, SendToCRM, Watchlist } from '../Common/tabs';
import { useUserPermit } from '../../context/User.context';
import '../Common/styles.css';
import { defaultSort, useSort } from '../../context/Sort.context';

const tabs = [
  {
    key: Routes.ao3Popular,
    label: TAB_NAME[POPULAR_AO3]
  },
  {
    key: Routes.ao3Watchlist,
    label: TAB_NAME[WATCHLIST_AO3]
  },
  {
    key: Routes.ao3Contacted,
    label: TAB_NAME[CONTACTED_AO3]
  },
  {
    key: Routes.ao3PodiumTitles,
    label: TAB_NAME[PODIUM_TITLES_AO3]
  },
  {
    key: Routes.ao3Excluded,
    label: TAB_NAME[ALL_EXCLUDED_AO3]
  },
  {
    key: Routes.ao3mutedAuthors,
    label: TAB_NAME[MUTED_AUTHORS_AO3]
  },
  {
    key: Routes.ao3SentToCRM,
    label: TAB_NAME[SENT_TO_CRM_AO3]
  }
];

const AO3Section: React.FC = ():JSX.Element => {
  const { view_tables } = useUserPermit();
  const { setSort } = useSort();
  const history = useHistory();

  return view_tables ? (
    <>
      <Tabs
        defaultActiveKey={AO3Endpoints[POPULAR_AO3]}
        onChange={key => {
          history.push(key);

          if (!window.location.search) {
            setSort(defaultSort);
          }
        }}
        tabs={tabs}
        activeKey={window.location?.pathname}
      />

      <Switch>
        <Route path={Routes.ao3Popular} render={() => <Popular />} />
        <Route path={Routes.ao3Watchlist} render={() => <Watchlist />} />
        <Route path={Routes.ao3Contacted} render={() => <Contacted />} />
        <Route path={Routes.ao3PodiumTitles} render={() => <PodiumTitles />} />
        <Route path={Routes.ao3Excluded} render={() => <AllExcluded />} />
        <Route path={Routes.ao3mutedAuthors} render={() => <MutedAuthors />} />
        <Route path={Routes.ao3SentToCRM} render={() => <SendToCRM />} />
        <Redirect to={Routes.ao3Popular} />
      </Switch>
    </>
  ) : (
    <></>
  );
};

export default AO3Section;